var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOvernight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24416 1.21896C6.00219 -0.170766 7.99771 -0.170765 8.75574 1.21896L13.3867 9.70898C14.1136 11.0417 13.149 12.6667 11.6309 12.6667H2.36904C0.850918 12.6667 -0.113709 11.0417 0.613245 9.70897L5.24416 1.21896ZM6.39678 9.66668C6.39678 9.29849 6.69525 9.00001 7.06344 9.00001C7.43163 9.00001 7.73011 9.29849 7.73011 9.66668C7.73011 10.0349 7.43163 10.3333 7.06344 10.3333C6.69525 10.3333 6.39678 10.0349 6.39678 9.66668ZM7.06344 4.00001C6.69525 4.00001 6.39678 4.29849 6.39678 4.66668V7.33335C6.39678 7.70154 6.69525 8.00001 7.06344 8.00001C7.43163 8.00001 7.73011 7.70154 7.73011 7.33335V4.66668C7.73011 4.29849 7.43163 4.00001 7.06344 4.00001Z",
    fill: "#F07300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvernight);
export default __webpack_public_path__ + "static/media/Overnight.21006139.svg";
export { ForwardRef as ReactComponent };